import React from "react";
import "./App.css";
import { Routes } from "../src/routes";
import { Footer } from "./Components/Common";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <>
      <Routes />
      <Footer />
      <ToastContainer
        position="top-center"
        autoClose={false}
        hideProgressBar={true}
        newestOnTop={false}
        rtl={false}
        draggable
      />
    </>
  );
}

export default App;
